/*
 * Copyright (c) 2015 - 2023 by KAA Soft. All rights reserved.
 */

import { adminConfig } from "../adminConfig";
import { httpRequest } from "./httpRequest";
import { updateList } from "./pagination";
import { popup } from "./popup";
import { loadingElement } from "./utils/loadingElement";
import { copyToClipboard } from "./utils/functions";

/**
 * @property {string} uploadRoute
 * @property {string} deleteRoute
 * @property {string} imageType
 * @property {string} relatedEntity
 * @property {string} relatedEntityValue
 */
export function imageUploaderInit(containerSelector) {
  if (containerSelector === void 0) {
    containerSelector = 'body';
  }
  var container = document.querySelector(containerSelector);
  var imageUploaderElements = container.querySelectorAll('.image-uploader');
  var _loop = function _loop() {
    var imageUploader = imageUploaderElements[i];
    var uploadInput = imageUploaderElements[i].querySelector('.image-uploader-input');
    var imageIdInput = imageUploaderElements[i].querySelector('.image-uploader-id');
    // let imagePreview = imageUploaderElements[i].querySelector('.image-uploader-preview');
    var imageDeleteBtn = imageUploaderElements[i].querySelector('.image-uploader-delete');
    // let imageUploadBtn = imageUploaderElements[i].querySelector('.image-uploader-upload');

    uploadInput.addEventListener('change', function (e) {
      var /**@type HTMLElement*/input = e.target;
      var uploadRoute = input.dataset.uploadRoute;
      var deleteRoute = input.dataset.deleteRoute;
      var type = input.dataset.type;
      var imageType = input.dataset.imageType;
      var relatedEntity = input.dataset.relatedEntity;
      var relatedEntityValue = input.dataset.relatedEntityValue;

      // let imageIdInput = container.querySelector('.image-id-input');
      var formData = new FormData();
      if (!imageType) return console.warn(adminConfig.messages.imageTypeNotSpecified);
      if (!uploadRoute || !deleteRoute) return console.warn(adminConfig.messages.routeNotSpecified);
      readImageFromURL(input, imageUploader);
      formData.append('file', input.files[0]);
      formData.append('type', imageType);
      if (relatedEntity) {
        formData.append(relatedEntity, relatedEntityValue);
      }
      if (type === 'settings') {
        formData.append('settingName', relatedEntity);
      }
      var headersObj = {
        'X-Requested-With': 'XMLHttpRequest',
        'Content-Type': 'multipart/form-data'
      };
      loadingElement.start(imageUploader);
      httpRequest({
        url: uploadRoute,
        data: formData,
        headers: headersObj
      }).then(function (response) {
        if (response && response.data) {
          // processRequestResponse(response.data);
          if (response.data.success) {
            if (imageIdInput && response.data.image.id) {
              imageIdInput.value = response.data.image.id;
            }
            if (imageIdInput && type === 'settings') {
              imageIdInput.value = response.data.image.webPath;
            }
            if (response.data.image.id) {
              imageDeleteBtn.dataset.route = deleteRoute.replace('[imageId]', response.data.image.id);
              imageDeleteBtn.classList.remove('d-none');
            }
          }
        }
      })["finally"](function () {
        loadingElement.finish(imageUploader);
      });
    });

    /**
     * @property {string} changeUrlState
     */
    imageDeleteBtn.addEventListener("click", function (e) {
      // if (!e.target.matches(".delete-image")) return;
      console.info('wow');
      e.preventDefault();
      var containerId, containerRoute, changeURLState, imageIdInput;
      var /**@type HTMLElement*/button = e.target;
      var route = button.dataset.route;
      var type = button.dataset.type ? button.dataset.type : 'widget'; // widget, list
      if (!route) return console.warn(adminConfig.messages.routeNotSpecified);
      var container = button.closest('.image-uploader');
      if (container) {
        imageIdInput = container.querySelector('.image-uploader-id');
      }
      if (type === 'list') {
        containerId = button.dataset.container;
        containerRoute = document.getElementById(containerId).dataset.route;
        changeURLState = button.dataset.changeUrlState ? button.dataset.changeUrlState === 'true' : true;
        if (!containerRoute) return console.warn(adminConfig.messages.routeNotSpecified);
      }
      popup({
        popupId: 'remove',
        route: route,
        confirm: function confirm(response) {
          if (response && response.data.success) {
            if (type === 'widget') {
              button.classList.add('d-none');
              if (imageIdInput) {
                imageIdInput.value = '';
              }
              container.querySelector('.image-uploader-preview img').remove();
            } else {
              // todo: remove route & changeState and check container
              updateList({
                containerId: containerId,
                routeURL: containerRoute,
                changeURLState: changeURLState
              });
            }
          }
        }
      });
    });
  };
  for (var i = 0; i < imageUploaderElements.length; i++) {
    _loop();
  }
  function readImageFromURL(input, container) {
    if (input.files && input.files[0]) {
      var reader = new FileReader();
      var file = input.files[0];
      var imagePreview = container.querySelector('.image-uploader-preview');
      var imagePreviewImg = imagePreview.querySelector('img');
      if (!imagePreviewImg) {
        var img = document.createElement('img');
        img.src = URL.createObjectURL(file);
        imagePreview.appendChild(img);
      } else {
        imagePreviewImg.src = URL.createObjectURL(file);
      }
      reader.onload = function () {
        console.info(imagePreview.querySelector('img'));
        console.info(imagePreview.querySelector('img').src);
        URL.revokeObjectURL(imagePreview.querySelector('img').src); // free memory
      };

      reader.readAsDataURL(file);
    }
  }
}

// Dropzone
export function dropzoneInit(containerSelector) {
  if (containerSelector === void 0) {
    containerSelector = 'body';
  }
  var container = document.querySelector(containerSelector);
  var dropzoneElements = container.querySelectorAll('.drop-zone');
  var _loop2 = function _loop2() {
    var dropzoneUploader = dropzoneElements[i];
    var uploadInput = dropzoneUploader.querySelector('.drop-zone-input');
    // let dropzoneContainer = dropzoneUploader.querySelector('.drop-zone-container');
    var uploadRoute = dropzoneUploader.dataset.uploadRoute;
    // let deleteRoute = dropzoneUploader.dataset.deleteRoute;
    // let type = dropzoneUploader.dataset.type;
    var imageType = dropzoneUploader.dataset.imageType;
    var relatedEntity = dropzoneUploader.dataset.relatedEntity;
    var relatedEntityValue = dropzoneUploader.dataset.relatedEntityValue;
    var containerId = dropzoneUploader.dataset.container;
    var changeURLState = dropzoneUploader.dataset.changeUrlState ? dropzoneUploader.dataset.changeUrlState === 'true' : true;
    ['drag', 'dragstart', 'dragend', 'dragover', 'dragenter', 'dragleave', 'drop'].forEach(function (event) {
      dropzoneUploader.addEventListener(event, function (e) {
        // preventing the unwanted behaviours
        e.preventDefault();
        e.stopPropagation();
      }, false);
    });
    ['dragover', 'dragenter'].forEach(function (event) {
      dropzoneUploader.addEventListener(event, function () {
        dropzoneUploader.classList.add('is-dragover');
      });
    });
    ['dragleave', 'dragend', 'drop'].forEach(function (event) {
      dropzoneUploader.addEventListener(event, function () {
        dropzoneUploader.classList.remove('is-dragover');
      });
    });
    // Input change event
    uploadInput.addEventListener('change', function (e) {
      var files = e.target.files;
      console.info(files);
      imageUpload(dropzoneUploader, files);
    });
    // Drop change event
    dropzoneUploader.addEventListener('drop', function (e) {
      var files = e.dataTransfer.files;
      imageUpload(dropzoneUploader, files);
    });
    function imageUpload(dropzoneItem, droppedFiles) {
      if (!imageType) return console.warn(adminConfig.messages.imageTypeNotSpecified);
      if (!containerId) return console.warn(adminConfig.messages.containerIdNotSpecified);
      var container = document.getElementById(containerId);
      if (!container) return console.warn(adminConfig.messages.containerNotExist);
      var containerRoute = document.getElementById(containerId).dataset.route;
      if (!containerRoute) return console.warn(adminConfig.messages.routeNotSpecified);
      if (dropzoneItem.classList.contains('is-uploading')) return false;
      if (!!droppedFiles) {
        dropzoneItem.classList.add('is-uploading');
        console.info(droppedFiles);
        var promises = [];
        Array.prototype.forEach.call(droppedFiles, function (file) {
          console.info(file);
          var formData = new FormData();
          formData.append(uploadInput.getAttribute('name'), file);
          formData.append('type', imageType);
          if (relatedEntity) {
            formData.append(relatedEntity, relatedEntityValue);
          }
          var headersObj = {
            'X-Requested-With': 'XMLHttpRequest',
            'Content-Type': 'multipart/form-data'
          };
          promises.push(httpRequest({
            url: uploadRoute,
            data: formData,
            headers: headersObj
          }));
        });
        axios.all(promises).then(axios.spread(function () {
          for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }
          for (var _i = 0; _i < args.length; _i++) {
            console.info('args[i].data =>', args[_i].data);
          }
        })).then(function () {
          updateList({
            containerId: containerId,
            routeURL: containerRoute,
            changeURLState: changeURLState
          });
        })["finally"](function () {
          dropzoneItem.classList.remove('is-uploading');
        });
      }
    }

    // Firefox focus bug fix for file input
    uploadInput.addEventListener('focus', function (e) {
      e.target.classList.add('has-focus');
    });
    uploadInput.addEventListener('blur', function (e) {
      e.target.classList.remove('has-focus');
    });
  };
  for (var i = 0; i < dropzoneElements.length; i++) {
    _loop2();
  }
}

/* todo: replace URL */
export function copyImagePath() {
  document.addEventListener("click", function (e) {
    if (!e.target.matches(".copy-image-path")) return;
    e.preventDefault();
    var path = e.target.dataset.path;
    copyToClipboard(path);
  });
  document.addEventListener("click", function (e) {
    if (!e.target.matches(".regenerate-images")) return;
    e.preventDefault();
    httpRequest({
      url: '/admin/image/regenerate'
    }).then(function (response) {
      console.info(response);
    })["finally"](function () {
      // graviton_app.loading.finish(form);
    });
  });
}

// export function bookImagesInit() {
// 	const bookImages = document.querySelectorAll('.book-media img');
// 	if (bookImages && typeof BigPicture === "function") {
// 		for (let i = 0; i < bookImages.length; i++) {
// 			bookImages[i].addEventListener('click', function (e) {
// 				e.preventDefault();
// 				BigPicture({
// 					el: e.target,
// 					gallery: bookImages,
// 					galleryAttribute: 'data-src',
// 					loop: true,
// 					onError: function () {
// 						console.warn('Error loading image')
// 					},
// 					animationStart: function () {
// 						document.documentElement.style.overflowY = 'hidden'
// 						document.body.style.overflowY = 'scroll'
// 					},
// 					onClose: function () {
// 						document.documentElement.style.overflowY = 'auto'
// 						document.body.style.overflowY = 'auto'
// 					},
// 				});
// 			})
// 		}
// 	}
// }